import {
  CalendarCheck,
  ClipboardCheck,
  CreditCard,
  FileCheck,
  Home,
  KeyRound,
  Landmark,
  type LucideIcon,
} from "lucide-react";
import type { OwnerNotificationKind } from "@/lib/owner-notification-feed";

/** One icon per owner-lifecycle event kind — shared by the Notifications
 *  feed rows and the Settings → Notifications preference groups, so the
 *  same event always reads the same visual shape in both places. */
export const OWNER_NOTIFICATION_ICONS: Record<OwnerNotificationKind, LucideIcon> = {
  portal_ready: Home,
  lease_signed: FileCheck,
  deposit_received: Landmark,
  keys_handed_over: KeyRound,
  move_in_protocol: ClipboardCheck,
  rent_received: CreditCard,
  move_out_date_confirmed: CalendarCheck,
  move_out_protocol: ClipboardCheck,
  keys_returned: KeyRound,
};
